<template>
  <div>
    <div v-if='newList' id="carouselExampleSlidesOnly3" class="carousel slide" :data-ride="'carousel'" :data-interval="'2000'">
      <ol class="carousel-indicators">
        <li v-for='(item,index) in newList' :key='index' data-target="#carouselExampleSlidesOnly3"
          :data-slide-to="index" :class="index==0?'active':''"></li>
      </ol>
      <div class="carousel-inner">
        <div v-for='(item,index) in newList' :class="index==0?'carousel-item active':'carousel-item'" :key='index'>
          <img @click='imgClick(item.thirdUrl)' :src="item.url" class="d-block w-100" :alt="item.alt">
        </div>
      </div>
    </div>

    <!-- <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for='(item,index) in bannerList'>
          <img @click='imgClick(item.thirdUrl)' :src="item.url" class="d-block w-100" :alt="item.alt">
        </div>
      </div>

    </div> -->
  </div>
</template>

<script>
  import Swiper from 'swiper';
  export default {
    props: {
      type: null
    },
    data() {
      return {
        bannerList: null,
        newList:null
      }
    },
   
    mounted() {
      this.$http({
        method: 'get',
        url: 'http://123.57.1.182/website/api/website/banner/list?type=' + this.type,
        data: {}
      }).then((res) => {
        console.log(res)
        this.bannerList = []
        if (res.data.code == 200) {
          res.data.data.map(item => {
            this.bannerList.push({
              url: item.titleImage,
              alt: item.title,
              thirdUrl: item.thirdUrl
            })
          })

// $('#carouselExampleSlidesOnly3').carousel('cycle')

/*
 <!-- 如果需要分页器 -->
 <div class="swiper-pagination"></div>

 <!-- 如果需要导航按钮 -->
 <div class="swiper-button-prev"></div>
 <div class="swiper-button-next"></div>

 <!-- 如果需要滚动条 -->
 <div class="swiper-scrollbar"></div>
 */
          // document.getElementById('carouselExampleSlidesOnly').carousel('cycle')
          this.$nextTick(() => {
            this.newList = JSON.parse(JSON.stringify(this.bannerList))
            // document.getElementsByClassName('carousel').carousel('cycle')
            /* let mySwiper = new Swiper('.swiper-container', {
              autoplay: true,
              loop: true,
              // 如果需要分页器
              pagination: '.swiper-pagination',
              // 如果需要前进后退按钮
              nextButton: '.swiper-button-next',
              prevButton: '.swiper-button-prev',
              // 如果需要滚动条
              scrollbar: '.swiper-scrollbar'

            }) */
          })
        }
      })


    },
    methods: {
      imgClick(url) {
        /* let path=window.location.protocol+'//'+url
        window.location.href=path */
        if (url) {
          window.open(url, '_blank')
        }
      },
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// carousel3.vue?4d2d9a3e